import { useMemo } from "react";
import HiddenPageForm from "../HiddenPageForm";
import { HiddenPageProps } from "../HiddenPageSingle";
import { EngineCondition } from "../../../models/Quote";
import enumToOptions from "../../../utils/enumToOptions";

export default function HiddenEngineCondition({register, setValue, watch}: HiddenPageProps) {
  const conditionOptions = useMemo(() => enumToOptions(EngineCondition), []);

  const schema = [
    {
      key: "engineCondition",
      label: "Engine Condition",
      type: "select",
      options: conditionOptions,
    },
  ]

  return (
    <HiddenPageForm 
      title={"Engine Condition"}
      description={"Fill out the engine condition details to prefill for this page."}
      register={register} 
      setValue={setValue} 
      watch={watch} 
      schema={schema} 
    />
  );
}